import styled, { keyframes } from 'styled-components'

export const StyledBoldSpan = styled.span`
  color: #282832;
  font-size: 12px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 700;
  line-height: 1.4;
  word-wrap: break-word;
`

export const StyledBoldSpan2 = styled.span`
  color: #282832;
  font-size: 12px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 700;
  line-height: 1.4;
`

export const StyledNormalSpan = styled.span`
  color: #282832;
  font-size: 12px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 400;
  line-height: 1.4;
  word-wrap: break-word;
`

export const StyledLinkSpan = styled.a`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.65;
  color: #009917;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  appearance: none;

  &:hover {
    text-decoration: none;
  }
`

export const StyledEarnText = styled.p`
  flex: 1 1 0;
  margin: 0;
  line-height: 19.8px;
`

export const StyledCarPartsFree = styled.div`
  display: flex;
  align-items: center;
`

export const StyledFrame1 = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const StyledCPRewards = styled.div`
  width: 100%;
  padding: 12px 8px;
  position: relative;
  background: #004C80;
  overflow: hidden;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px #004C80 solid;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
  box-sizing: border-box;
`

export const StyledCPFREE = styled.div`
  width: 100%;
  border-radius: 4px;
  outline: 1px #004C80 solid;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  position: relative;
`

export const StyledFrame2 = styled.div`
  flex: 1 1 0;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
`

export const StyledVehicleLabel = styled.div`
  flex: 1 1 0;
  padding-left: 6px;
  padding-right: 6px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 6px;
  display: flex;
`

export const StyledSuggestionRow = styled.div`
  width: 100%;
  padding: 8px;
  background: white;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  box-sizing: border-box;
`

export const StyledPointsApply = styled.span`
  color: #333333;
  font-size: 12px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 400;
  line-height: 1.4;
  word-wrap: break-word;
`;

export const StyledPointsApplytoSubtotal = styled.p`
  align-self: stretch;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 0;
`;

export const StyledArrow = styled.div`
  position: absolute;
  bottom: -11px;
`;

export const StyledIconWrapper = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
`

export const StyledTooltipnew = styled.div`
  position: absolute;
  bottom: 31px;
  left: 0;
  right: 0;
  padding: 4px 8px;
  z-index: 10;
  background: white;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2px;
  display: flex;
`

export const shimmer = keyframes`
  0% { background-position: -400% 0; }
  100% { background-position: 400% 0; }
`

export const StyledSkeletonHeader = styled.div`
  width: 100%;
  height: 48px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background: linear-gradient(90deg, #003d66 25%, #005491 50%, #003d66 75%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.8s ease-in-out infinite;
  box-sizing: border-box;
`

export const StyledSkeletonRow = styled.div`
  width: 100%;
  padding: 8px;
  background: white;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-sizing: border-box;
`

export const StyledSkeletonLine = styled.div<{ width?: string }>`
  height: 12px;
  width: ${({ width }) => width ?? '100%'};
  border-radius: 4px;
  background: linear-gradient(90deg, #e8e8e8 25%, #f4f4f4 50%, #e8e8e8 75%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.8s ease-in-out infinite;
`

export const StyledSkeletonContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  outline: 1px #004C80 solid;
  display: flex;
  flex-direction: column;
`

export const StyledBonusDaysAlert = styled.div`
    display: block;
    width: 100%;
    box-sizing: border-box;
    color: #C23030;
    font-size: 10px;
    font-family: "Roboto", Arial, Helvetica, sans-serif;
    font-weight: 600;
    line-height: 14.85px;
    word-wrap: break-word;
`

export const StyledBonusdaysAlertDetails = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: 4px 4px 4px 7px;
    background: #DAF4FF;
    border-bottom: 1px #004C80 solid;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    display: flex;
`
